import { ReactNode, useEffect } from 'react'
import useKycStore from './kycStore'
import { useFetchKYC } from './kycQueries'
import useAccountStore from '@/account/accountStore'

const KycProvider = ({ children }: { children: ReactNode }) => {
    const activeAccountId = useAccountStore((s) => s.activeAccountId)
    const { setKyc, setKycComplete } = useKycStore()

    const { data: kyc } = useFetchKYC(activeAccountId, { enabled: true })

    useEffect(() => {
        if (!kyc) return
        if (kyc) {
            setKyc(kyc)
            setKycComplete(Boolean(kyc.status === 'VERIFICATION_SUCCESS'))
        }
    }, [kyc, setKyc, setKycComplete])

    return <>{children}</>
}

export default KycProvider
